
import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { AuthContext } from './AuthContext';
import './User.css';

const HASH_SECRET = '9e107d9d372bb6826bd81d3542a419d6';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://quickreact.onrender.com/login', formData);
      const { email, isSubscribed } = response.data;

      // Encrypt isSubscribed before storing in localStorage
      const encryptedIsSubscribed = CryptoJS.AES.encrypt(String(isSubscribed), HASH_SECRET).toString();
      login(email, encryptedIsSubscribed);

      setMessage('Login successful! Redirecting...');
      setTimeout(() => {
        navigate('/container/login');
      }, 2000); // Redirects after 2 seconds
    } catch (error) {
      console.error('Login error:', error);
      setMessage('Login failed. Please check your credentials and try again.');
    }
  };

  return (
    <div className="signup-container">
      <div id="loginc">
        <div className="login-cont">
          <div className="head">
            <h1>Login</h1>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="inputs">
              <div className="input-email">
                <label className="label" htmlFor="email">Email</label>
                <br />
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="input"
                />
              </div>
              <div className="input-password">
                <label className="label" htmlFor="password">Password</label>
                <br />
                <input
                  type="password"
                  id="password"
                  name="password"
                  required
                  value={formData.password}
                  onChange={handleChange}
                  className="input"
                />
              </div>
              {message && <div className="message">{message}</div>}
            </div>
            <div className="check-btn">
              <button type="submit" className="button2">Login</button>
              <Link to="/signup">Don't have an account?</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
